import * as prismic from "@prismicio/client";

// -- Prismic API endpoint
const apiEndpoint = "https://illinois-squeeze-upside.cdn.prismic.io/api/v2";
// -- Access Token if the repository is not public
const accessToken =
  "MC5haG52N3hFQUFDZ0FtUDlX.77-9Au-_ve-_ve-_ve-_ve-_ve-_vVLvv71BTkXvv708W1Lvv73vv73vv71vAe-_vX7vv73vv73vv73vv71u77-9S--_vQ";
// -- Prismic Client
const PrismicClient = prismic.createClient(apiEndpoint, { accessToken });

export default PrismicClient;
